import { render } from "./ChangeEmail.vue?vue&type=template&id=812e47a0&ts=true"
import script from "./ChangeEmail.vue?vue&type=script&lang=ts"
export * from "./ChangeEmail.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src3516746311/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__